var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDoubleLeftUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2371 1.46225C9.94602 1.17925 9.48259 1.17925 9.19149 1.46225L3.47721 7.01781C3.18022 7.30655 3.17353 7.78138 3.46227 8.07836C3.75101 8.37535 4.22584 8.38204 4.52283 8.0933L9.7143 3.04603L14.9058 8.0933C15.2028 8.38204 15.6776 8.37535 15.9663 8.07836C16.2551 7.78137 16.2484 7.30655 15.9514 7.01781L10.2371 1.46225Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2574 5.98276C10.1158 5.83412 9.91956 5.75 9.7143 5.75C9.50905 5.75 9.31276 5.83412 9.1712 5.98276L3.45691 11.9828C3.25 12.2 3.19248 12.5197 3.31066 12.7954C3.42884 13.0712 3.7 13.25 4.00002 13.25H8.9643V19C8.9643 21.0711 10.6432 22.75 12.7143 22.75H20C20.4142 22.75 20.75 22.4142 20.75 22C20.75 21.5858 20.4142 21.25 20 21.25H12.7143C11.4717 21.25 10.4643 20.2426 10.4643 19V13.25H15.4286C15.7286 13.25 15.9998 13.0712 16.1179 12.7954C16.2361 12.5197 16.1786 12.2 15.9717 11.9828L10.2574 5.98276Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDoubleLeftUp);
export default __webpack_public_path__ + "static/media/corner-double-left-up.0c50f31103e0cca31dceb21d83d5a7c5.svg";
export { ForwardRef as ReactComponent };